var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-digital-resources__message hiq-search-message"},[(!_vm.loading)?_c('p',{staticClass:"hiq-digital-resources__message-text hiq-search-message__text",attrs:{"aria-live":"polite"}},[_vm._v(" Listan innehåller "+_vm._s(_vm.total)+" objekt. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }